export enum EnumStaffRole {
    INSTRUMENTALIST = 'instrumentiste',
    ROOM_HELPER = 'op',
    ANESTHETIST = 'anaesthetist',
    NURSE_ANESTHETIST = 'iade',
}
